export default __webpack_public_path__ + "static/media/shop3.573300f2.mp4";